<template>
  <div class="view-content view9">
    <div class="view9-header">
        <div class="left">
            <div class="title">{{ $t('NECO 生态系统') }}</div>
            <div class="text text-padding">{{ $t('一个融合金融、科技与商业的去中心化生态。') }}</div>
        </div>
        <div class="right div-no">
            <img class="img" src="./img/1030/view9-1.png">
        </div>
    </div>
    <div class="view9-ul">
        <div class="view9-li" v-for="(item, index) in list" :key="index">
            <div class="view9-title">{{ item.title }}</div>
            <div class="view9-text">{{ item.text }}</div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'view9',
  data () {
    return {
        list: [
            {
                title: this.$t('Neco Chain 公链'),
                text: this.$t('商业级高速 Layer 2 网络（Novai L2），提供结算与数据验证基础设施。'),
            },
            {
                title: this.$t('NECO App'),
                text: this.$t('用户购物、签到、邀请与分销的统一入口。'),
            },
            {
                title: this.$t('USAI 稳定币'),
                text: this.$t('用于平台内支付与结算的稳定币资产，锚定美元价值。'),
            },
            {
                title: this.$t('U Card 全球消费卡'),
                text: this.$t('连接线上线下消费场景，支持积分抵扣与现金返还。'),
            },
            {
                title: this.$t('NECO AI 智能系统'),
                text: this.$t('通过 AI 分析用户行为，实现个性化推荐与安全风控。'),
            },
            {
                title: this.$t('消费金融该协议'),
                text: this.$t('提供通用的去中心化金融基础设施，支持电商资产流通。'),
            },
            {
                title: this.$t('稳定币生态'),
                text: this.$t('构建覆盖支付、结算与跨境流通的稳定币网络。'),
            },
        ]
    }
  },
}
</script>

<style scoped>
@import "./css/index.css";

.view9 {
    flex-direction: column;
    justify-content: flex-start;
}

.view9 .label {
    padding-top: 0;
}

.view9 .label {
    padding-right: 200px;
    color: #fff;
}

.view9 .img {
    width: 20vw;
}

.view9-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.view9-ul {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
    padding-top: 20px;
}

.view9-li {
    width: 24%;
    
    box-sizing: border-box;
    padding: 32px;
    gap: 10px;
    /* flex: 1 0 0; */
    align-self: stretch;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.10);
}

.view9-title {
    font-size: 24px;
    font-weight: 600;
}

.view9-text {
    padding-top: 10px;
    font-size: 16px;
    font-weight: 600;
}

@media screen and (max-width: 768px) {
    .view9 {
        justify-content: center;
    }
    .div-no {
        display: none;
    }
    .view9-ul {
        display: block;
    }
    .view9-li {
        width: 100%;
        padding: 0;
        background: none;
    }
    .view9-title {
        font-size: 16px;
        padding-top: .4rem;
    }
    .view9-text {
        padding-top: 5px;
        font-size: 14px;
        opacity: 0.5;
        font-weight: 400;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/lobby/components1030/view9.vue